import React from 'react';
import { useAtom } from 'jotai';
import { approvalFilter } from '@/recoil/atom';
import SortPopover from '@/components/Approval/@components/SortPopover';

const approvalSortList: { value: string; title: string }[] = [
  { value: 'authoredAt', title: '최근 등록순' },
  { value: 'updatedAt', title: '최근 업데이트순' },
];

/**
 * 정렬 드롭다운. 기존 SearchApproval 에 묶여 있던 정렬을 분리해
 * "총 N건" 옆(SubHeader)에 배치한다. 선택 시 approvalFilter.sortType 갱신.
 */
const ApprovalSort = () => {
  const [filters, setFilters] = useAtom(approvalFilter);

  const handleSelected = (value: string) => {
    setFilters({ ...filters, sortType: value });
  };

  return <SortPopover list={approvalSortList} handleSelected={handleSelected} />;
};

export default ApprovalSort;
